import { requestWithToken } from '../utilities/request';
const path = '/api/private/user_notice_settings';

const list = () => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/list'),
  });
};

/**
 *
 * @param data {object}
 */
const submit = data => {
  return requestWithToken(
    {
      method: 'POST',
      url: path,
      data,
    },
    false
  );
};

export const userNoticeSettingsService = {
  list,
  submit,
};
export default userNoticeSettingsService;



// WEBPACK FOOTER //
// ./src/services/UserNoticeSettings.js